export const DEFAULT_LOGO = '/placeholder-logo.svg';
export const DEFAULT_BANNER = '/placeholder-banner.svg';

export function resolveStoreLogo(store) {
  if (!store) return DEFAULT_LOGO;

  return (
    store.logo_url ||
    store.logo ||
    store.imagem ||
    store.image ||
    DEFAULT_LOGO
  );
}

export function resolveStoreBanner(store) {
  if (!store) return DEFAULT_BANNER;

  return (
    store.banner_url ||
    store.cover_url ||
    store.cover_image ||
    store.wallpaper_url ||
    store.image ||
    store.logo_url ||
    DEFAULT_BANNER
  );
}

export function resolveStoreCardImage(store) {
  return resolveStoreBanner(store);
}
